
    import './styles.scoped.css';
    export default {
  "button-dropdown": "awsui_button-dropdown_sne0l_1vpm4_99",
  "items-list-container": "awsui_items-list-container_sne0l_1vpm4_103",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_sne0l_1vpm4_1",
  "rotate-up": "awsui_rotate-up_sne0l_1vpm4_122",
  "rotate-down": "awsui_rotate-down_sne0l_1vpm4_137",
  "header": "awsui_header_sne0l_1vpm4_152",
  "title": "awsui_title_sne0l_1vpm4_163",
  "description": "awsui_description_sne0l_1vpm4_164",
  "split-trigger-wrapper": "awsui_split-trigger-wrapper_sne0l_1vpm4_168",
  "trigger-item": "awsui_trigger-item_sne0l_1vpm4_171",
  "trigger-button": "awsui_trigger-button_sne0l_1vpm4_174",
  "visual-refresh": "awsui_visual-refresh_sne0l_1vpm4_185",
  "split-trigger": "awsui_split-trigger_sne0l_1vpm4_168",
  "dropdown-trigger": "awsui_dropdown-trigger_sne0l_1vpm4_193",
  "test-utils-button-trigger": "awsui_test-utils-button-trigger_sne0l_1vpm4_197"
};
  